// for Mac
// : . /
// for Windows
// < > : " / \ | ? * ^
export const filenameReservedCharacter = /[<>:"/\\|?*.^]/gi;
